export default __webpack_public_path__ + "static/media/tab2_icon3.318c2a32.svg";